/**
 * ryde-oto-countdown.js
 * Shared countdown timer for OTO hero, bundle, and final CTA sections.
 *
 * Keeps all 3 existing HTML structural variations completely in sync
 * from a single session-stored end time.
 */

(function () {
  'use strict';

  var SESSION_KEY = 'ryde_oto_end';

  function pad(n) {
    return String(n).padStart(2, '0');
  }

  function getEndTime() {
    var stored = sessionStorage.getItem(SESSION_KEY);
    if (stored) return parseInt(stored, 10);

    // Read duration from whichever primary elements contain the attribute data-minutes
    var el = document.getElementById('oto-countdown');
    var minutes = el ? parseInt(el.getAttribute('data-minutes'), 10) : 60; // Defaults to 60 as per your structure
    if (isNaN(minutes) || minutes < 1) minutes = 60;

    var end = Date.now() + minutes * 60 * 1000;
    sessionStorage.setItem(SESSION_KEY, end);
    return end;
  }

  function setDigits(hours, minutes, seconds) {
    var paddedHours = pad(hours);
    var paddedMinutes = pad(minutes);
    var paddedSeconds = pad(seconds);

    // --- Structure 1: Main/Hero Elements ---
    var hh = document.getElementById('oto-hours');
    var mm = document.getElementById('oto-minutes');
    var ss = document.getElementById('oto-seconds');
    if (hh) hh.textContent = paddedHours;
    if (mm) mm.textContent = paddedMinutes;
    if (ss) ss.textContent = paddedSeconds;

    // --- Structure 2: Bundle Elements & Text Inline Timer ---
    var bhh = document.getElementById('oto-bundle-hours');
    var bmm = document.getElementById('oto-bundle-minutes');
    var bss = document.getElementById('oto-bundle-seconds');
    if (bhh) bhh.textContent = paddedHours;
    if (bmm) bmm.textContent = paddedMinutes;
    if (bss) bss.textContent = paddedSeconds;

    // Update the inline label text inside the bundle "THIS OFFER EXPIRES IN: [MM:SS]"
    var bundleBar = document.querySelector('.oto-bundle__timer-bar > span');
    if (bundleBar) {
      // Formats string format to [MM:SS] or [HH:MM:SS] if there's hours left
      var timeString = hours > 0 ? paddedHours + ':' + paddedMinutes + ':' + paddedSeconds : paddedMinutes + ':' + paddedSeconds;
      bundleBar.textContent = 'THIS OFFER EXPIRES IN: [' + timeString + ']';
    }

    // --- Structure 3: Final CTA Elements ---
    var fhh = document.getElementById('oto-final-hours');
    var fmm = document.getElementById('oto-final-minutes');
    var fss = document.getElementById('oto-final-seconds');
    if (fhh) fhh.textContent = paddedHours;
    if (fmm) fmm.textContent = paddedMinutes;
    if (fss) fss.textContent = paddedSeconds;
  }

  function tick(endTime) {
    var remaining = Math.max(0, Math.floor((endTime - Date.now()) / 1000));
    var h = Math.floor(remaining / 3600);
    var m = Math.floor((remaining % 3600) / 60);
    var s = remaining % 60;
    setDigits(h, m, s);
    return remaining;
  }

  function init() {
    // Run if any of the three countdown blocks exist on the current page view
    if (
      !document.getElementById('oto-countdown') &&
      !document.getElementById('oto-countdown-bundle') &&
      !document.getElementById('oto-countdown-final')
    ) return;

    var endTime = getEndTime();
    tick(endTime);

    var interval = setInterval(function () {
      var remaining = tick(endTime);
      if (remaining <= 0) {
        clearInterval(interval);
        
        // Softly fade out matching layout bars when expired
        var bars = document.querySelectorAll('.oto-timer-bar, .oto-bundle__timer-bar');
        bars.forEach(function (bar) {
          bar.style.opacity = '0.4';
        });
      }
    }, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
